var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"join-us-bg"},[(!_vm.loggedIn)?_c('div',{staticClass:"img-box",on:{"click":_vm.register}},[_c('p',[_vm._v(_vm._s(_vm.$t("Home.join_tit")))])]):_vm._e(),_c('p',{staticClass:"join-txt"},[_vm._v(_vm._s(_vm.$t("Home.join_txt")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }